import React, { FunctionComponent } from 'react'

import Scaffold from '../../../shared/components/Scaffold'
import { formatBreadCrumb } from '../BasePage/formatBreadCrumb'
import { IBasePageComponent } from './ContainerPageComponent.types'
import { BreadCrumb, Title, Content } from './styles'

const ContainerPage: FunctionComponent<IBasePageComponent> = ({
  breadCrumb,
  showFooterScaffold = true,
  onClickBackButton,
  onClickNextButton,
  titleBackButton,
  titleNextButton,
  isNextButtonDisabled = false,
  iconButtonNext,
  children,
  colorNextButton,
  title,
  loading,
  showScaffold = true,
  header,
  tabComponent,
  filter,
  overflow,
  backgroundColor,
  boxShadow,
  padding,
}) => {
  return (
    <Content overflow={overflow}>
      <BreadCrumb>
        <Title>{formatBreadCrumb(breadCrumb)}</Title>
      </BreadCrumb>
      {header && header}
      {tabComponent && tabComponent}
      {filter && filter}
      {showScaffold && (
        <Scaffold
          onClickBackButton={onClickBackButton}
          onClickNextButton={onClickNextButton}
          titleBackButton={titleBackButton}
          titleNextButton={titleNextButton}
          isNextButtonDisabled={isNextButtonDisabled}
          showFooterScaffold={showFooterScaffold}
          icon={iconButtonNext}
          color={colorNextButton}
          title={title}
          loading={loading}
          backgroundColor={backgroundColor}
          boxShadow={boxShadow}
          padding={padding}
        >
          {children}
        </Scaffold>
      )}
      {!showScaffold && <> {children} </>}
    </Content>
  )
}

export default ContainerPage
